import { useEffect, useState } from 'react'

import { motion } from 'framer-motion'

interface LoadingOverlayProps {
  message?: string
}

export const LoadingOverlay = ({
  message = 'Loading...',
}: LoadingOverlayProps) => {
  const [showLoader, setShowLoader] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(true)
    }, 1500)

    return () => clearTimeout(timer)
  }, [])

  if (!showLoader) return null

  return (
    <motion.div
      className="fixed inset-0 z-100 flex items-center justify-center bg-background/80 backdrop-blur-sm lg:ml-[300px]"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="w-64">
        <div className="mb-4 text-center text-lg font-medium">{message}</div>
        <div className="h-2 w-full overflow-hidden rounded-full bg-secondary-50 dark:bg-secondary-400">
          <motion.div
            className="h-full bg-gradient-to-r from-primary-400 to-primary-600"
            initial={{ width: '0%' }}
            animate={{
              width: '100%',
              transition: {
                repeat: Infinity,
                duration: 1.5,
                ease: 'easeInOut',
              },
            }}
          />
        </div>
      </div>
    </motion.div>
  )
}
